"use client";

import React, { createContext, useContext, useState } from 'react';
import type { Mood, MoodContextValue } from '@/types/dashboard';

const STORAGE_KEY = 'delphina_mood';

const MoodContext = createContext<MoodContextValue | undefined>(undefined);

export function MoodProvider({ children }: { children: React.ReactNode }) {
  const [mood, setMoodState] = useState<Mood>(() => {
    if (typeof window !== 'undefined') {
      const stored = localStorage.getItem(STORAGE_KEY) as Mood | null;
      if (stored && ['anxious', 'unclear', 'clear', 'comfortable'].includes(stored)) {
        return stored;
      }
    }
    return 'anxious';
  });
  const [isMoodSet, setIsMoodSet] = useState(() => {
    if (typeof window !== 'undefined') {
      const stored = localStorage.getItem(STORAGE_KEY) as Mood | null;
      return !!(stored && ['anxious', 'unclear', 'clear', 'comfortable'].includes(stored));
    }
    return false;
  });

  const setMood = (newMood: Mood) => {
    console.log('[MoodContext] setMood called, newMood:', newMood);
    setMoodState(newMood);
    setIsMoodSet(true);
    localStorage.setItem(STORAGE_KEY, newMood);
  };

  return (
    <MoodContext.Provider value={{ mood, setMood, isMoodSet }}>
      {children}
    </MoodContext.Provider>
  );
}

const defaultMoodContext: MoodContextValue = {
  mood: 'anxious' as const,
  setMood: () => {},
  isMoodSet: false,
};

export function useMood() {
  const context = useContext(MoodContext);
  if (!context) {
    return defaultMoodContext;
  }
  return context;
}
